function sortByName(a, b) {
    if (a.name < b.name) {
        return -1
    }
    if (a.name > b.name) {
        return 1
    }
    return 0
}

function toKebabCase(str) {
    return str && str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.toLowerCase())
        .join('-')
}

export class Content {
    constructor(id, name) {
        this.id = id
        this.name = name
    }

    get urlName() {
        return toKebabCase(this.name)
    }
}

export class View extends Content {
    constructor(id, name, contentUrl, workbookId, firstTag) {
        super(id, name)

        this.contentUrl = contentUrl.replace('/sheets', '')
        this.workbookId = workbookId
        this.firstTag = firstTag ? firstTag.replace(/_/g, ' ') : null
    }
}

export class ViewCategory {
    constructor(name) {
        this.name = name,
            this.views = []
    }

    addView(v) {
        this.views.push(v)
        this.views.sort(sortByName)
    }
}

export class ViewList {
    constructor() {
        this.categories = []
    }

    addCategory(c) {
        this.categories.push(c)
        this.categories.sort(sortByName)
    }

    getCategory(c) {
        return this.categories.filter(x => x.name === c)[0]
    }
}

export class Insight {
    constructor(insight) {
        this.heading = insight.insightHeading
        this.code = insight.code
        this.body = insight.insightText
        this.dateTime = insight.dateTime
        this.read = insight.read
        this.contentUrl = insight.tableauLink
        this.brand = insight.brand
        this.vertical = insight.vertical
        this.product = insight.product
    }
}

export class FilterConfiguration {
    constructor(filterConfiguration) {
        this.name = filterConfiguration.name
        this.displayName = filterConfiguration.displayName
        this.filterType = filterConfiguration.filterType
        this.options = filterConfiguration.options
        this.label = filterConfiguration.label
        this.minValue = filterConfiguration.minValue
        this.maxValue = filterConfiguration.maxValue
        this.length = filterConfiguration.length
        this.vertical = filterConfiguration.vertical
    }
}

export class Aggregator {
    constructor(aggregator) {
        this.aggregatorName = aggregator.aggregatorName
        this.vertical = aggregator.vertical
    }
}

export class User {
    constructor(user) {
        this.name = user.name
        this.fullName = user.fullName
        this.company = new Company(user.company)
        this.internalUser = user.internalUser
        this.featureFlags = user.featureFlags || {}
    }

    get initials() {
        let names = this.fullName.split(' ')
        return names.length > 1 ? `${names[0][0]}${names[1][0]}` : names[0][0]
    }
}

export class Company {
    constructor(company) {
        this.name = company.name
        this.features = company.features
    }

    hasFeature(feature) {
        return this.features.indexOf(feature) >= 0
    }
}

export class Filter {
    constructor() {
        this.name = ''
        this.name2 =''
        this.option = ''
        this.operator = ''
        this.logicalOperator = ''
        this.value = ''
        this.value2 = ''
        this.stringValue = ''
        this.arithmeticOperator =''
    }
}

export class FilterSet {
    constructor(filterSet) {
        this.ID = filterSet.ID
        this.name = filterSet.name
        this.updated = filterSet.updated
        this.created = filterSet.created
        this.userName = filterSet.userName
        this.companyName = filterSet.companyName
        this.data = filterSet.data
    }    
}
